import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';
import { ParagraphPropsJssProps } from 'components/Paragraph';

export const isParagraph = (
  component: ComponentRendering
): component is ParagraphPropsJssProps & ComponentRendering => {
  return component.componentName === 'Paragraph';
};
